$(document).ready(() => {
    // Our Story - Staff Profiles
    $('.staff-pro').click(function(){
        if (!$(this).hasClass('active')){
        	 
	        $('.staff-pro').removeClass('active').find('.staff-bio').slideUp();
	        $(this).addClass('active');
	        $(this).find('.staff-bio').slideDown();
        }
        
    });	
});



// WEBPACK FOOTER //
// ./src/js/profiles.js